import { render, staticRenderFns } from "./AlarmOption.vue?vue&type=template&id=1664915a&scoped=true&"
import script from "./AlarmOption.vue?vue&type=script&lang=js&"
export * from "./AlarmOption.vue?vue&type=script&lang=js&"
import style0 from "./AlarmOption.vue?vue&type=style&index=0&id=1664915a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664915a",
  null
  
)

export default component.exports